import {
  SALARY_ALL,
  SALARY_DELETE,
  SALARY_GET,
  SALARY_LOADING,
  SALARY_POST,
  SALARY_PUT,
} from '../type';

function SalaryReducer(state = { salary: null }, action) {
  switch (action.type) {
    case SALARY_LOADING:
      return { isLoading: true };
    case SALARY_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case SALARY_POST:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case SALARY_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case SALARY_PUT:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case SALARY_DELETE:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    default:
      return state;
  }
}

export default SalaryReducer;
